import { AfterViewInit, Component } from '@angular/core';
import { OfferService } from '@services/offer/offer.service';
declare var FlipDown: any;
@Component({
  selector: 'app-countdown',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.scss']
})
export class CountDownComponent implements AfterViewInit {


  constructor(private offerService: OfferService) { }

  async ngAfterViewInit() {
    const countdownDate =  await this.offerService.readCountDownDate();
    const time = countdownDate.getTime() / 1000;
    new FlipDown(time, { theme: 'light', headings: ['Dias', 'Horas', 'Minutos', 'Segundos'] }).start();
  }
}
